import Luiv3Constants, {LuiV3ColorKey} from '@app/lui3/constants';
import styled from 'styled-components';

import BtnContainer from '../BtnContainer';
import AbsLayer from './AbsLayer';

interface Props {
  backgroundColor: LuiV3ColorKey;
  hoverColor: LuiV3ColorKey;
}

const TextButtonInteractionLayer = styled(AbsLayer)<Props>`
  background-color: ${({backgroundColor}) =>
    Luiv3Constants.baseColor[backgroundColor]};

  ${BtnContainer}:hover & {
    background-color: ${({hoverColor}) => Luiv3Constants.baseColor[hoverColor]};
  }
  ${BtnContainer}:focus-visible & {
    background-color: ${({hoverColor}) => Luiv3Constants.baseColor[hoverColor]};
  }
`;

export default TextButtonInteractionLayer;
